<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="patInfo !== undefined && patInfo !== null">

      <b-row class="borde-azul-reducir">
        <b-col :cols="mostrarDetalle?5:12" class="borde-azul-reducir-fondo">
          <b-row style="height: 100px">
            <div style="text-align: right;position: absolute; width: 100%;z-index: 100;">
              <b-badge v-if="patInfo.idTipoPaciente === 1"
                       style="border:solid gray 1px; background:white; color:black;">{{ patInfo.tipoPaciente }}
              </b-badge>
              <b-badge v-else style="background:#eefff1; color:#49c37f;">{{ patInfo.tipoPaciente }}</b-badge>
            </div>
            <b-col cols="3">
              <div v-if="patInfo !== undefined && patInfo.idSexo !== undefined && patInfo.idSexo < 3"
                   style="width:160%;margin-top:4px">

                <img alt="paciente" style="max-height:100px" v-if="patInfo.idSexo===1" src="@/assets/paciente/paciente.png"/>
                <img alt="paciente" style="max-height:100px" v-if="patInfo.idSexo===2" src="@/assets/paciente/paciente2.png"/>

              </div>

              <img alt="paciente" v-else style="max-height:100px" src="@/assets/paciente/paciente3.png"/>
            </b-col>
            <b-col cols="7">
              <div style="top:20%;position: relative;font-size: 14px;margin-left: 25px; width: 116%">
                <span style="color: #FFFFFF; font-weight: bold; font-size: 12px">{{ patInfo.nombrePaciente }}</span>
                <p class="mt-2" style="color: #FFFFFF; font-size: 12px">{{ patInfo.fechaNacimientoCompleta }}</p>
              </div>
            </b-col>
            <b-col xm="0" sm="0" md="0" lg="2" xl="2">
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="7" v-if="mostrarDetalle">
          <b-row class="detalle-formulario" style="margin-top: 8px">
            <b-col xm="12" sm="12" md="12" lg="3" xl="3" class="mb-2">
              <label>ID paciente</label>
              <span>{{ patInfo.idPaciente }}</span>
            </b-col>
            <b-col xm="12" sm="12" md="12" lg="3" xl="4" class="mb-2">
              <label>Estatus del paciente</label>
              <span v-if="patInfo.registroActivo">Activo</span>
              <span v-else>Inactivo</span>
            </b-col>
            <b-col xm="12" sm="12" md="12" lg="3" xl="3" class="mb-2">
            </b-col>
            <b-col xm="12" sm="12" md="12" lg="3" xl="2" class="mb-2">
            </b-col>
            <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mb-2">
              <label>Teléfono</label>
              <span v-if="patInfo.celular!=null">{{ patInfo.celular | VMask("(###) - ### - ####") }}</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>

  </template>
  
  <script>
  
  export default {
    name: "cardPerfilPaciente",
    components: {},
    props: {
      mostrarDetalle: {
        likes: Boolean,
        default: true
      },
      patInfo: {
        likes: Object,
        required: false,
        default: null
      }
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }),
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    whatch: {},
    computed: {},
    methods: {}
  }
  </script>
  
  <style scoped>
  
  </style>
  